import React, {Component} from 'react'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import Truncate from 'react-truncate';
import axios from 'axios'
import { SET_PROFILE_OPEN, SET_LIKES_POPUP_ACTIVE } from '../../Actions/Sidebar'
import { LIKE, UNLIKE, SET_CHAT_POPUP, REMOVE_MESSAGE } from '../../Actions/Wazzup'
import { ReportIcon, RemoveIcon } from '../../Svg/Index'
import { endpoint } from '../../config'


class Card extends Component {

    state = {
        addLike: 0,
        hasLiked: false,
        liked: false,
        dialogActive: false,
    }

    componentDidMount() {
        let userLikes = this.props.currentUser.likes;
        if(userLikes) {
            if(userLikes.includes(this.props.id)) {
                this.setState({
                    liked: true
                })
            }
        }
    }

    handleGoToThread = (id, user)=> {
        const { type, enabled, isGroup, asPopup, uuid } = this.props

        if(enabled === false) return;

        if(asPopup) {
            this.props.actions.SET_CHAT_POPUP(null).then(()=> {
                this.props.actions.SET_CHAT_POPUP(uuid, document.querySelectorAll('.o-web-container')[0].scrollTop)
            })
        } else {
            if(type === 'chat') {
                this.props.history.push({
                    pathname: `/chat`,
                    threadId: id,
                    user: user
                })
            } else if(type === 'wazzup') {
                this.props.history.push({
                    pathname: `/wazzup/chat/${id}`,
                    isGroup: isGroup
                })
            }
        }
    }

    openProfile = (props)=> {
        if(props?.user?.roles.includes("ROLE_ANONYMOUS")) return;
        this.props.actions.SET_PROFILE_OPEN(props.user._id)
        document.body.classList.add('sidebar-open');
    }

    handleLike = ()=> {
        let userLikes = this.props.currentUser.likes;
        if(!userLikes.includes(this.props.id)) {
            this.props.actions.LIKE(this.props.uuid)
            this.setState({addLike: this.state.addLike += 1, liked: true})
        } else {
            this.props.actions.UNLIKE(this.props.uuid)
            this.setState({addLike: this.state.addLike -= 1, liked: false})
        }
    }

    openLikesPopup = () => {
        this.setState({
            likesPopupActive: true
        });
        this.props.actions.SET_LIKES_POPUP_ACTIVE(this.props.uuid)
        document.body.classList.add('is-blurred');
        
    }

    handleReport = () => {

        if (window.confirm("Weet je zeker dat je dit bericht wilt rapporteren?")) {

            axios({
                url: `${endpoint}/api/mail/flag-message/${this.props.id}`,
                method: 'POST',
                data: {
                    "user": {
                        "_id": this.props.user
                    }
                },
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${this.props.currentUser.token}`,
                    'content-type': 'multipart/form-data',
                }, 
            }).then(res => {
                
                // SHOW ALERT MESSAGE SUCCESSFUL REPORTED
                alert('Dit bericht wordt behandeld door het Jong&Out team. Bedankt voor het melden.')    
            })
        }
    }

    handleRemoveDialog = (id) => {
        this.setState({
            dialogActive: true,
            removingMessage: id
        })        
    }

    handleMessageRemove = () => {
        
        this.props.actions.REMOVE_MESSAGE(this.state.removingMessage).then((res)=> {
            this.setState({
                dialogActive: false,
                removingMessage: null
            })

            this.props.afterDelete()

        })
    }

    render() {
        const { uuid, author, authorImage, createdAt, body, image, messageCount, user, type, unread, roles, pinned, like_count, showLikes, asPopup } = this.props;
        
        let isCoordinator = false;

        if(roles) {
            isCoordinator = roles.includes("ROLE_COORDINATOR") === true ? true : false
        }

        return (
            <>
               
                <div className={`c-card ${unread === true ? 'c-card--unread' : '' } ${pinned === true ? 'c-card--pinned' : '' }`}>

                {
                    this.state.dialogActive && (
                        <div className="c-dialog">
                            <div className="c-dialog__inner">
                                <h2>Wil je dit bericht verwijderen?</h2>
                                <button className="c-btn c-btn--primary" onClick={this.handleMessageRemove}>Ja, verwijder</button>
                                <button className="c-btn c-btn--primary" onClick={ () => this.setState({dialogActive: false}) }>Nee, annuleren</button>
                            </div>
                        </div>
                    )
                }

                    <div className="c-card__inner">
                        {
                            pinned && (
                                <svg class="c-card__pinned" width="20px" height="24px" viewBox="0 0 20 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
                                    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                        <g id="Group-9">
                                            <polygon id="Rectangle" fill="#3E0A93" points="0 0 20 0 20 24 10 21.5172414 0 24"></polygon>
                                            <g id="noun_Pin_1143673" transform="translate(10.000000, 12.000000) rotate(-330.000000) translate(-10.000000, -12.000000) translate(6.000000, 6.000000)" fill="#FFFFFF" fillRule="nonzero">
                                                <path d="M7.40625,7.5 C7.425,7.66875 7.275,7.8375 7.10625,7.8375 L4.1625,7.8375 L4.1625,10.8375 C4.1625,11.0625 3.975,11.25 3.75,11.25 C3.525,11.25 3.3375,11.0625 3.3375,10.8375 L3.3375,7.8375 L0.39375,7.8375 C0.225,7.8375 0.075,7.6875 0.09375,7.5 C0.20625,6.3375 0.84375,5.325 1.8,4.725 L1.8,2.19375 C1.29375,1.725 0.9375,1.0875 0.84375,0.375 C0.825,0.1875 0.975,0.01875 1.1625,0.01875 L6.3375,0.01875 C6.525,0.01875 6.69375,0.1875 6.65625,0.375 C6.5625,1.10625 6.225,1.74375 5.7,2.19375 L5.7,4.725 C6.65625,5.325 7.29375,6.31875 7.40625,7.5 Z" id="Path"></path>
                                            </g>
                                        </g>
                                    </g>
                                </svg>
                            )
                        }
                        <div className="c-card__author" style={{cursor: 'pointer' }} onClick={() => { this.openProfile(this.props) }}>
                            <img src={authorImage} alt=""/>
                        </div>
                        <div className="c-card__content" onClick={() => this.handleGoToThread(uuid, user)}>
                            <div className="c-card__label u-small">
                                <span className={`${isCoordinator ? 'u-primary' : ''}`}>{isCoordinator ? '★ ' : ''}{author}{isCoordinator ? ' ★ ' : ''}</span>
                                <span>{createdAt}</span>
                            </div>
                            {
                                image && (
                                    <div className="c-card__media">
                                        <img src={image.message_medium} alt=""/>
                                    </div>
                                )
                            }
                            <div className="c-card__message">
                                <Truncate lines={3}>
                                    {body}
                                </Truncate>
                            </div>

                            {
                                type === 'wazzup' && (
                                    <Link to={`/wazzup/chat/${uuid}`} className="u-small u-bare" style={{pointerEvents: asPopup ? 'none' : 'all'}}>
                                        {
                                            messageCount === 0 && ( <> Geef de eerste reactie </> )
                                        }
                                        {
                                            messageCount === 1 && ( <> Eerste reactie bekijken </> )
                                        }
                                        {
                                            (messageCount !== 1 && messageCount !== 0) && ( <> Alle {messageCount} reacties bekijken </> )
                                        }
                                    </Link>
                                )
                            }
                        </div>

                        

                        {
                            showLikes && (
                                <div className={`c-card__like ${this.state.liked ? 'is-liked' : ''}`}>
                                    
                                    {
                                        this.props.currentUser._id === user._id ? (
                                            <span className="c-card__remove" onClick={() => { 
                                                this.handleRemoveDialog(this.props.item.first_message._id)
                                             }}><RemoveIcon /></span>
                                        ) : (
                                            <button className="c-card__report" onClick={this.handleReport}>
                                                <ReportIcon />
                                            </button>
                                        )
                                    }
                                    

                                    

                                    {
                                        like_count + this.state.addLike > 0 && (
                                            <span className="c-card__like-counter" onClick={this.openLikesPopup.bind(this)}>{like_count + this.state.addLike}</span>
                                        )
                                    }
                                    <div className="c-card__like-trigger" onClick={this.handleLike.bind(this)}>
                                        <svg width="17px" height="16px" viewBox="0 0 17 16">
                                            <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                                <path className="svg-element" d="M8.5,14.7625 L7.4125,13.7725 C3.55,10.27 1,7.96 1,5.125 C1,2.815 2.815,1 5.125,1 C6.43,1 7.6825,1.6075 8.5,2.5675 C9.3175,1.6075 10.57,1 11.875,1 C14.185,1 16,2.815 16,5.125 C16,7.96 13.45,10.27 9.5875,13.78 L8.5,14.7625 Z"  stroke="#B6BCBD" strokeWidth="1.6" fillRule="nonzero"></path>
                                            </g>
                                        </svg>
                                    </div>
                                </div>
                            )
                        }
                        
                    </div>
                </div>
            </>
            
        )
    }
}
const mapStateToProps = state => {
    return {
        currentUser: state.user.user,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        actions: bindActionCreators({REMOVE_MESSAGE, SET_PROFILE_OPEN, LIKE, UNLIKE, SET_LIKES_POPUP_ACTIVE, SET_CHAT_POPUP }, dispatch)
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Card))